import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getRetirementDefinitionsAction } from "../actions";
import { getLoading, getData } from "../selectors";
import { Grid } from "@material-ui/core";
import DataItem from "./data/dataItem";
import { RESET_STATE } from "../actionTypes";
import ABMLayout from "@icarius-common/abmComponents/abmLayout";
import paths from "@icarius-router/paths";
import { getLocalizedString } from "@icarius-localization/strings";

const RetirementDefinition = ({ history }) => {

  const [createIsOpen, setCreateIsOpen] = useState(false);

  const dispatch = useDispatch();
  const data = useSelector(getData);
  const isLoading = useSelector(getLoading);

  useEffect(() => {
    dispatch(getRetirementDefinitionsAction());
    return () => { dispatch({ type: RESET_STATE }) }
  }, [dispatch])

  const getDataIsEmpty = () => {
    return !data || data.length === 0;
  }

  const handleGoBack = () => {
    history.push(paths.affiliationInstitutionDefinition);
  }

  return (
    <ABMLayout
      title={getLocalizedString("retirementDefinition")}
      isLoading={isLoading}
      showCreateButton={!createIsOpen}
      createButtonTitle={getLocalizedString("newPrevisionInstitution")}
      createButtonOnClick={() => setCreateIsOpen(true)}
      showNoData={getDataIsEmpty()}
      noDataTitle={getLocalizedString("noForecastInstitutionsFound")}
      noDataCreateTitle={getLocalizedString("newPrevisionInstitution")}
      noDataOnClick={() => setCreateIsOpen(true)}
      showGoBack
      handleGoBack={handleGoBack}
    >
      {
        createIsOpen &&
        <Grid container item xs={12} style={{ margin: "10px 0px" }}>
          <DataItem
            data={null}
            closeNew={() => setCreateIsOpen(false)}
          />
        </Grid>
      }
      {
        data && data.map((item) => {
          return (
            <Grid container item xs={12} style={{ margin: "10px 0px" }} key={item.code}>
              <DataItem data={item} />
            </Grid>
          )
        })
      }
    </ABMLayout>
  )
}

export default RetirementDefinition;